import React from 'react';
import { TCategory } from '../model';

type CategoryListItemProps = {
    id: string;
    item: TCategory;
    isSelected: boolean;
    onToggle: () => void;
}

const CategoryListItem = ({ id, item, isSelected, onToggle } : CategoryListItemProps) => {

    return (
        <div id={id} onClick={onToggle} className="tw-flex tw-cursor-pointer tw-items-center tw-mb-2 tw-">
            <input
                type="radio"
                checked={isSelected}
                onChange={onToggle}
                className="tw-mr-2"
            />
            <span className='tw-text-[#172B4D] tw-text-sm'>{item?.name ?? ''}</span>
        </div>
    );
};

export default CategoryListItem;